<template lang="pug">
svg.time-marker-figure(
  width="10"
  height="23"
  viewBox="0 0 10 23"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
)
  path(
    d="M7.85547 0C6.79405 0 5.93359 0.860453 5.93359 1.92188V6.83398C5.84581 6.86042 5.75909 6.90041 5.67578 6.9541L0.459961 10.3154C-0.150897 10.7092 -0.150897 11.6033 0.459961 11.9971L5.67578 15.3584C5.75909 15.4121 5.84581 15.4521 5.93359 15.4785V20.3916C5.93359 21.453 6.79405 22.3135 7.85547 22.3135C8.91689 22.3135 9.77734 21.453 9.77734 20.3916V1.92188C9.77734 0.860453 8.91689 0 7.85547 0Z"
  )
</template>

<script>
export default {
  name: 'IconTimeMarkerEnd',
};
</script>
